module.exports = __webpack_public_path__ + "static/media/image-auto.f98202d3.png";